import { CommonModalProps } from 'components/CommonModal/context';
import { ModalCloseOptions } from 'constants/modals/modalCloseOptions';
import { ModalSeverityValues } from 'constants/modals/modalSeverityValues';

const unexpectedErrorModal: CommonModalProps = {
  id: 'unexpectedErrorModal',
  severity: ModalSeverityValues.ERROR,
  buttons: [
    {
      buttonText: 'OK',
      buttonValue: ModalCloseOptions.OK,
      onClick: () => window.location.reload(),
    },
  ],
  messageText: [
    'These problems are normally temporary. Please refresh the page, restart your browser or try again a little later.',
  ],
  responseStatus: 503, // Prevent Google indexing the error
  titleText: "Sorry, we're experiencing an unexpected error.",
  cannotClose: true,
};

export default unexpectedErrorModal;
